/** Còn lịch nào đang có nút "Chép tin" không (khách đã xác nhận sẽ đến thì không còn nút — `CanNhac.tsx`). */
export function conLichCanBam(ds: readonly { daXacNhan: boolean }[]): boolean {
  return ds.some((x) => !x.daXacNhan)
}
